const environment = {
  baseURL: import.meta.env.VITE_API_BASE_URL || "https://localhost:44361/api/",
  appEnv: import.meta.env.VITE_APP_ENV || "development",
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  mode: import.meta.env.MODE,
};

export default environment;
